"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRolePermissionUpdateModel = instanceOfRolePermissionUpdateModel;
exports.RolePermissionUpdateModelFromJSON = RolePermissionUpdateModelFromJSON;
exports.RolePermissionUpdateModelFromJSONTyped = RolePermissionUpdateModelFromJSONTyped;
exports.RolePermissionUpdateModelToJSON = RolePermissionUpdateModelToJSON;
exports.RolePermissionUpdateModelToJSONTyped = RolePermissionUpdateModelToJSONTyped;
/**
 * Check if a given object implements the RolePermissionUpdateModel interface.
 */
function instanceOfRolePermissionUpdateModel(value) {
    return true;
}
function RolePermissionUpdateModelFromJSON(json) {
    return RolePermissionUpdateModelFromJSONTyped(json, false);
}
function RolePermissionUpdateModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'menuNo': json['menuNo'] == null ? undefined : json['menuNo'],
        'ugNo': json['ugNo'] == null ? undefined : json['ugNo'],
        'menuAuth': json['menuAuth'] == null ? undefined : json['menuAuth'],
        'functionIds': json['functionIds'] == null ? undefined : json['functionIds'],
    };
}
function RolePermissionUpdateModelToJSON(json) {
    return RolePermissionUpdateModelToJSONTyped(json, false);
}
function RolePermissionUpdateModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'menuNo': value['menuNo'],
        'ugNo': value['ugNo'],
        'menuAuth': value['menuAuth'],
        'functionIds': value['functionIds'],
    };
}
